import { Injectable } from '@angular/core';
declare var speechSynthesis: any;

@Injectable({
  providedIn: 'root'
})
export class TextToSpeechService {
  selectedVoice: any = null;
  isMute: boolean = false;
  isCompatible: boolean = false;

  constructor() {}

  init() {
    this.isCompatible = 'speechSynthesis' in window;
    if (this.isCompatible) {
      speechSynthesis.onvoiceschanged = () => {
        this.selectedVoice = speechSynthesis.getVoices().find((o: any) => o.name.includes('Mark'));
      };
    }
  }

  isInitiated(isMute: boolean = false) {
    this.isMute = isMute;
  }

  changeSpeakingMode(isMute: boolean) {
    if (this.isCompatible) {
      if (isMute) speechSynthesis.cancel();

      this.isMute = isMute;
    }
  }

  speak(text: string) {
    if (this.isCompatible) {
      const linkRegex = /<a(.*?)a>/g;
      let message = text.replaceAll(linkRegex, '');

      const spanRegex = /<span(.*?)span>/g;
      message = message.replaceAll(spanRegex, '');

      // Replace 'minus' with 'negative'
      message = message.replaceAll('-', 'negative ');

      // Replace bold html
      message = message.replaceAll('<b>', '').replaceAll('</b>', '');

      // Do some preprocessing for text before sent to speak
      if (!this.isMute) {
        const utterance = new SpeechSynthesisUtterance(message);
        utterance.voice = this.selectedVoice;

        this.verbalize(utterance);
      }
    }
  }

  verbalize(utterance: SpeechSynthesisUtterance) {
    // this.speechSynthesisRef.cancel();
    // this.speechSynthesisRef.speak(utterance);
    if(this.isCompatible) {
      speechSynthesis.cancel();
      speechSynthesis.speak(utterance);
    }
  }

  stop() {
    if (this.isCompatible) {
      speechSynthesis.cancel();
    }
  }
}
